let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hAzu1")).then(() => parcelRequire('2BtXU'));